module.exports = __webpack_public_path__ + "img/icon_renwshu.22a87441.svg";